import React from 'react';

import TextareaField from '~fields/TextareaField';
import TextField from '~fields/TextField';
import { Gap } from '~ui-kit';

const CleaningForm = () => {
  return (
    <>
      <TextField name="locationText" fallbackLabel="Paikka" required />
      <Gap height="24px" />
      <TextareaField
        name="informationText"
        fallbackLabel="Lisätietoa"
        rows={5}
      />
    </>
  );
};

export default CleaningForm;
